import React from 'react'
import { Tooltip } from 'antd'
import type { Organization } from '../../types'
import { isCurrentSessionOrganization } from '../../utils'

export type PlanUpgradeIntent = 'invite' | 'add'

interface PlanUpgradeHintProps {
  organization: Organization
  currentCustomerId?: string | null
  intent?: PlanUpgradeIntent
  onUpgrade?: (organization: Organization) => void
  children: React.ReactNode
}

export function planUpgradeTooltipTitle(
  organization: Organization,
  currentCustomerId?: string | null,
  onUpgrade?: (organization: Organization) => void,
  intent: PlanUpgradeIntent = 'invite',
): React.ReactNode {
  const action = intent === 'add' ? 'add users' : 'invite users'
  if (isCurrentSessionOrganization(organization, currentCustomerId)) {
    return (
      <div className="um-refactor__upgrade-tooltip">
        <div>Upgrade <strong>{organization.name}</strong> to Business to {action}.</div>
        {onUpgrade && (
          <button
            type="button"
            className="um-refactor__upgrade-tooltip-action"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              onUpgrade(organization)
            }}
          >
            Upgrade now
          </button>
        )}
      </div>
    )
  }

  return (
    <div className="um-refactor__upgrade-tooltip">
      Switch to <strong>{organization.name}</strong> in the organization switcher, then upgrade to Business.
    </div>
  )
}

const PlanUpgradeHint: React.FC<PlanUpgradeHintProps> = ({
  organization,
  currentCustomerId,
  intent = 'invite',
  onUpgrade,
  children,
}) => (
  <Tooltip
    overlayClassName="um-refactor__upgrade-tooltip-overlay"
    mouseEnterDelay={0.1}
    mouseLeaveDelay={0.35}
    title={planUpgradeTooltipTitle(organization, currentCustomerId, onUpgrade, intent)}
  >
    <span className="um-refactor__upgrade-hint">{children}</span>
  </Tooltip>
)

export default PlanUpgradeHint
